// Thin wrapper over window.gtag, set up in public/index.html only when
// REACT_APP_GA_MEASUREMENT_ID is configured at build time. Every export is a
// safe no-op when gtag isn't present, so this file never needs to know
// whether GA4 is actually enabled. Consent is handled entirely by iubenda's
// Google Consent Mode v2 integration (see public/index.html) - this module
// does not gate calls on consent itself, it relies on Consent Mode to
// suppress/model them correctly.
import type { AnalyticsProperties } from "../types";

type Gtag = (...args: unknown[]) => void;

declare global {
    interface Window {
        gtag?: Gtag;
    }
}

function gtag(...args: unknown[]): void {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    window.gtag(...args);
}

export function pageview(path: string): void {
    gtag("event", "page_view", { page_path: path });
}

export function event(name: string, properties: AnalyticsProperties): void {
    gtag("event", name, properties);
}

export function identify(userId: string): void {
    // GA4 user_id must be set via config/set, not gtag('event', ...).
    gtag("set", { user_id: userId });
}

export function reset(): void {
    gtag("set", { user_id: undefined });
}
